module.exports = __webpack_public_path__ + "img/dstv-error-fix-1.806428e4.jpg";